<div (click)="activate($event)" (keydown)="keydown($event, widget)" attr.telemetry="{{widget.title}} Widget"
  class="widget" [ngClass]="widgetColor(widget.color)" tabindex="0" role="button">
  <div>
    <div class="widget-icon--container">
      <forge-icon class="widget-icon" [name]="widget.icon"></forge-icon>
    </div>

    <div fxLayout="column" fxLayoutAlign="space-between">
      <div fxLayout="row" fxLayoutAlign="space-between center" class="widget-text widget-title">
        <truncate-text [mainText]="widget.title">
        </truncate-text>
        <!-- *ngIf="hasMenu" -->
        @if (hasMenu) {
          <forge-menu [options]="menuOptions" placement="bottom-start"
            (forge-menu-select)="menuItemSelected($event)" (forge-menu-open)="menuOpened($event)">
            <forge-icon-button dense (click)="stopTileClick($event)"
              attr.telemetry="{{widget.title}} action menu">
              <forge-tooltip placement="bottom">Actions</forge-tooltip>
              <forge-icon name="more_vert"></forge-icon>
            </forge-icon-button>
          </forge-menu>
        }
      </div>

      <div class="widget-count--container">
        <forge-icon name="open_in_new" [hidden]="hasCount()" class="forge-typography--heading8">
        </forge-icon>

        <div class="forge-typography--heading8 widget-count" [hidden]="!hasCount()">
          <truncate-text [mainText]="widget.count">
          </truncate-text>
        </div>
      </div>

      <div class="forge-typography--label1 widget-text">
        <truncate-text [mainText]="widget.secondaryText">
        </truncate-text>
      </div>
    </div>
  </div>
</div>